import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { useLocation, useNavigate } from 'react-router-dom';
import { FollowUpResultProgress } from '../followUpResultProgress/FollowUpResultProgress';
import { FollowUpResultPerformance } from '../followUpResultPerformance/FollowUpResultPerformance';
import CoachingGlidePath from '../../../components/coachingActionPlan/coachingGlidePath/CoachingGlidePath';
import { ReviewAdjust } from '../reviewAdjust/ReviewAdjust';
import { CoachingHistory } from '../coachingHistory/CoachingHistory';
import './FollowUpStep.scss';

interface FollowUpStepProps {
    CAPSession: any;
    coachingActionPlanId?: number;
}

export const FollowUpStep: React.FC<FollowUpStepProps> = ({ CAPSession, coachingActionPlanId }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [reviewExpanded, setReviewExpanded] = useState<boolean>(true);

    const metricIndex = CAPSession?.metricIndex ?? 0;
    const handleBackToPrepare = () => {
        sessionStorage.removeItem('cap_nav_intent');
        navigate(location.pathname, {
            replace: true,
            state: {
                activeStep: 0,
                coachingActionPlanId: null,
                coachingActionPlanSessionId: null
            }
        });
    };
    const latestSession = CAPSession?.sessions?.reduce((max: any, s: any) =>
        s.sessionNumber > max.sessionNumber ? s : max
        , CAPSession?.sessions?.[0]);

    return (
        <div className="follow-up-container">
            <CoachingGlidePath pageType="follow-up" CAPSession={CAPSession} />

            <div className="follow-up-layout">
                <div className="follow-up-layout__history">
                    <CoachingHistory coachingActionPlanId={coachingActionPlanId ?? 0}
                        CAPSessionData={CAPSession}
                    />
                </div>

                <div className="follow-up-layout__content">
                    <div className="follow-up-layout__results">
                        <FollowUpResultProgress CAPSession={CAPSession} metricIndex={metricIndex} />
                        <FollowUpResultPerformance CAPSession={CAPSession} metricIndex={metricIndex} onBackToPrepare={handleBackToPrepare} />
                    </div>
                    <div className="follow-up-layout__review" style={{ display: CAPSession?.coachingNextBestActionTypeId === 4 ? 'block' : 'none' }}>
                        <div
                            className={`review-adjust-toggle ${reviewExpanded ? 'review-adjust-toggle--expanded' : ''}`}
                            onClick={() => setReviewExpanded(!reviewExpanded)}
                            onKeyDown={(e: React.KeyboardEvent) => e.key === 'Enter' && setReviewExpanded(!reviewExpanded)}
                            role="button"
                            tabIndex={0}
                        >
                            <i className={`pi ${reviewExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} />
                            <h4 className="review-adjust-toggle__title">Review & Adjust</h4>
                        </div>
                        {reviewExpanded && (
                            <div className="review-adjust-toggle__content">
                                <ReviewAdjust
                                    CAPSession={CAPSession}
                                />
                            </div>
                        )}
                    </div>
                    {CAPSession?.coachingNextBestActionTypeId !== 4 && (latestSession?.followUpDate && new Date() >= new Date(latestSession.followUpDate)) && (
                        <div className="follow-up-layout__other-actions" style={{ marginTop: '24px' }}>
                            <ReviewAdjust
                                CAPSession={CAPSession}
                                showOnlyOtherActions
                                latestSession={latestSession}
                            />
                        </div>
                    )}
                    <div className="review-adjust__back">
                        <Button
                            label="Back to Prepare"
                            icon="pi pi-arrow-circle-left"
                            className="review-adjust__back-btn"
                            onClick={handleBackToPrepare}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};